import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomersInfo, IRithmicView } from "../../api/evaluations/index.types";

export interface IEvaluationsState {
  data: {
    evaluations: {
      report: IRithmicView[];
      customersInfo: ICustomersInfo[];
      count: number;
    };
    loading: boolean;
  };
}

const initialState: IEvaluationsState = {
  data: {
    evaluations: {
      report: [],
      customersInfo: [],
      count: 0,
    },
    loading: false,
  },
};

const index = createSlice({
  name: "evaluations",
  initialState,
  reducers: {
    fetchEvaluationsRequest: (state) => {
      state.data.loading = true;
    },
    fetchEvaluationsSuccess: (
      state,
      action: PayloadAction<{
        report: IRithmicView[];
        customersInfo: ICustomersInfo[];
      }>
    ) => {
      state.data.loading = false;
      state.data.evaluations.report = action.payload.report;
      state.data.evaluations.customersInfo = action.payload.customersInfo;
      state.data.evaluations.count = action.payload.report[0]?.full_count;
    },
    fetchEvaluationsFailed: (state) => {
      state.data.loading = false;
    },
  },
});

export const evaluationsActions = index.actions;
export default index.reducer;
